import { render, staticRenderFns } from "./AllClaimTypesReporting.vue?vue&type=template&id=24a89326"
import script from "./AllClaimTypesReporting.vue?vue&type=script&lang=js"
export * from "./AllClaimTypesReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports